import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../../components/Modal/Modal';
import { Types } from '../common';
import styles from './styles.scss';

function TechnicalProblem({ handleCloseModal, type }) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen
      handleClose={handleCloseModal}
      classNames={{
        titleClassName: styles.ModalTitle,
        bodyClassName: styles.ModalBody,
        closeClassName: styles.ModalClose
      }}
      title={t('containers.logIn.technicalProblem.title')}
      contentStyle={{
        maxWidth: '623px',
        width: 'calc(100% - 40px)'
      }}
    >
      {type === Types.Call
        ? t('containers.logIn.technicalProblem.phone-call')
        : t('containers.logIn.technicalProblem.phone-sms')
      }
    </Modal>
  );
}

export default TechnicalProblem;



// WEBPACK FOOTER //
// ./src/containers/Login/Form/TechnicalProblem/index.js